exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".small-sort-icon svg{height:10px!important}", ""]);

// exports
